import React from 'react'
import DefaultSettingManagement from './abstract/DefaultSettingManagement'
import Window from '../../../../common/Window'
import StyleAdmin from '../../../style/StyleAdmin'
import Loading from '../../../../common/component/Loading'

class KenkouSetting extends DefaultSettingManagement {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false, offset: false}
    this.systemSettingName = 'KenkouSetting'
  }
  onInsert (offset) {
    offset = Number(offset)
    const KenkouSetting = this.getSettingData()
    const lastKenkouSetting = KenkouSetting[offset]
    KenkouSetting.splice(offset + 1, 0,
      {
        startMonth: lastKenkouSetting.startMonth + 100,
        endMonth: lastKenkouSetting.endMonth + 100,
        ryouritsuList: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0
        ]
      }
    )
    this.setState({
      offset: offset + 1,
      KenkouSetting: KenkouSetting,
      KenkouSettingInputData: JSON.parse(JSON.stringify(KenkouSetting))
    })
  }
  onDelete (offset) {
    if (this.getSettingData().length > 1) {
      Window.confirm('この行を削除してもよろしいですか?', () => {
        offset = Number(offset)
        const KenkouSetting = this.getSettingData()
        KenkouSetting.splice(offset, 1)
        this.setState({
          offset: false,
          KenkouSetting: KenkouSetting,
          KenkouSettingInputData: JSON.parse(JSON.stringify(KenkouSetting))
        })
        Window.closeDialog()
      })
    }
  }
  onMoveUp (offset) {
    offset = Number(offset)
    if (offset > 0) {
      const KenkouSetting = this.getSettingData()
      KenkouSetting.splice(offset - 1, 2, KenkouSetting[offset], KenkouSetting[offset - 1])
      this.setState({
        offset: false,
        KenkouSetting: KenkouSetting,
        KenkouSettingInputData: JSON.parse(JSON.stringify(KenkouSetting))
      })
    }
  }
  onMoveDown (offset) {
    offset = Number(offset)
    const KenkouSetting = this.getSettingData()
    if (offset < KenkouSetting.length - 1) {
      offset++
      KenkouSetting.splice(offset - 1, 2, KenkouSetting[offset], KenkouSetting[offset - 1])
      this.setState({
        offset: false,
        KenkouSetting: KenkouSetting,
        KenkouSettingInputData: JSON.parse(JSON.stringify(KenkouSetting))
      })
    }
  }
  onSwitchTerm (offset) {
    this.setState({
      offset: offset
    })
  }
  changed (index, attributeName, e) {
    const KenkouSetting = this.state.KenkouSetting
    KenkouSetting[index][attributeName] = parseInt(e.target.value)
    this.setState({
      KenkouSetting: KenkouSetting,
      KenkouSettingInputData: JSON.parse(JSON.stringify(KenkouSetting))
    })
  }
  changePrefectureData (monthOffset, prefectureOffset, e) {
    const KenkouSetting = this.state.KenkouSetting
    const KenkouSettingInputData = this.state.KenkouSettingInputData
    let changedValue = e.target.value

    // 整数と、少点数以外を除く
    changedValue = changedValue.replace(/[^0-9.]/g, '')
    // input用データ
    KenkouSettingInputData[monthOffset].ryouritsuList[prefectureOffset] = changedValue
    // 保存用データ（小数を含む整数にする）
    KenkouSetting[monthOffset].ryouritsuList[prefectureOffset] = parseFloat(changedValue)
    this.setState({
      KenkouSetting: KenkouSetting,
      KenkouSettingInputData: KenkouSettingInputData
    })
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const KenkouSetting = this.getSettingData()
    const KenkouInputSetting = this.state.KenkouSettingInputData
    const yearMonthList = this.getYMList(6, 201509).reverse()
    const yearMonthListToShow = []
    yearMonthList.forEach(ym => {
      yearMonthListToShow.push(
        <option key={this.uuid()} value={ym.id}>{ym.name}</option>
      )
    })
    let PrefectureTable = []
    const PrefectureList = this.getPrefectureList()
    if (this.state.offset !== false) {
      const PrefectureListToShow = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((row, index) => { // forだと誤作動
        return (
          <tr key={this.state.offset * 100 + row}>
            <th className='kw-ds-no'>{PrefectureList[row].id}</th><th className='kw-text-pl5'>{PrefectureList[row].name}</th><td><input type='text' value={KenkouInputSetting[this.state.offset].ryouritsuList[row]} onChange={(e) => this.changePrefectureData(this.state.offset, (row), e)} /></td>
            <th className='kw-ds-no'>{PrefectureList[row + 10].id}</th><th className='kw-text-pl5'>{PrefectureList[row + 10].name}</th><td><input type='text' value={KenkouInputSetting[this.state.offset].ryouritsuList[row + 10]} onChange={(e) => this.changePrefectureData(this.state.offset, (row + 10), e)} /></td>
            <th className='kw-ds-no'>{PrefectureList[row + 20].id}</th><th className='kw-text-pl5'>{PrefectureList[row + 20].name}</th><td><input type='text' value={KenkouInputSetting[this.state.offset].ryouritsuList[row + 20]} onChange={(e) => this.changePrefectureData(this.state.offset, (row + 20), e)} /></td>
            <th className='kw-ds-no'>{PrefectureList[row + 30].id}</th><th className='kw-text-pl5'>{PrefectureList[row + 30].name}</th><td><input type='text' value={KenkouInputSetting[this.state.offset].ryouritsuList[row + 30]} onChange={(e) => this.changePrefectureData(this.state.offset, (row + 30), e)} /></td>
            <th className='kw-ds-no'>{(row + 40 < 47) ? PrefectureList[row + 40].id : ''}</th><th className='kw-text-pl5'>{(row + 40 < 47) ? PrefectureList[row + 40].name : ''}</th><td><input type='text' value={(row + 40 < 47) ? KenkouInputSetting[this.state.offset].ryouritsuList[row + 40] : ''} style={{display: (row + 40 < 47) ? 'inline' : 'none'}} onChange={(e) => this.changePrefectureData(this.state.offset, (row + 40), e)} /></td>
          </tr>)
      })
      const startMonth = KenkouSetting[this.state.offset].startMonth
      const endMonth = KenkouSetting[this.state.offset].endMonth
      PrefectureTable = (
        <div key={this.state.offset}>
          <h6 className='alert alert-block alert-success'>【No.{this.state.offset + 1}】 :
            {Math.floor(startMonth / 100) + '年' + (startMonth % 100) + '月'} - {Math.floor(endMonth / 100) + '年' + (endMonth % 100) + '月の 都道府県毎の健康保険料率単価'}</h6>
          <table className='kw-ds-detail-tbl'>
            <thead>
              <tr>
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-ryouritsu' />
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-ryouritsu' />
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-ryouritsu' />
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-ryouritsu' />
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-ryouritsu' />
              </tr>
            </thead>
            <tbody>
              {PrefectureListToShow}
            </tbody>
          </table>
        </div>
      )
    }
    const kenkouSettingToShow =
    KenkouSetting.map((kenkou, index, list) => {
      const isTop = (index === 0)
      const isBottom = (index === list.length - 1)
      const isOnlyOne = (list.length <= 1)
      return (
        <tr key={index}>
          <th className='kw-ds-no'>{index + 1}</th>
          <td><select value={kenkou.startMonth} onChange={(e) => this.changed(index, 'startMonth', e)} >{yearMonthListToShow}</select></td>
          <td><select value={kenkou.endMonth} onChange={(e) => this.changed(index, 'endMonth', e)} >{yearMonthListToShow}</select></td>
          <td className='kw-ds-ryouritsu'><a onClick={this.onSwitchTerm.bind(this, index)}>編集</a></td>
          <td className='kw-ds-gyou-sousa-icons'>
            <span className='text-success'><i className='icon-plus-sign kw-pointer' onClick={this.onInsert.bind(this, index)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={this.onDelete.bind(this, index)}
              style={isOnlyOne ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={isTop ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveUp.bind(this, index)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={isBottom ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveDown.bind(this, index)} /></span>
          </td>
        </tr>
      )
    })
    return (
      <form id='userSecurityForm' className='form-horizontal' method='post' onSubmit={this.onSubmit.bind(this)}>
        <div className='row'>
          <fieldset className='kw-ds-regist-area span16'>
            <legend>健康保険</legend>
            <div className='alert alert-block alert-info'>
              <p>
                必要な情報を入力して最後に「登録」ボタンを押してください。
              </p>
            </div>
            <table>
              <thead>
                <tr>
                  <th className='kw-ds-no' />
                  <th className='kw-ds-start-month' />
                  <th className='kw-ds-end-month' />
                  <th className='kw-ds-ryouritsu' />
                  <th className='kw-ds-gyou-sousa' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style={StyleAdmin.defaultSetting.textCenter}>No.</th>
                  <th className='kw-ds-start-month'>適用開始年月</th>
                  <th className='kw-ds-end-month'>適用終了年月</th>
                  <th style={StyleAdmin.defaultSetting.textCenter}>保険料率</th>
                  <th style={StyleAdmin.defaultSetting.textCenter}>行操作</th>
                </tr>
                {kenkouSettingToShow}
              </tbody>
            </table>
            {PrefectureTable}
            <footer id='submit-actions' className='form-actions'>
              <button id='submit-button' type='submit' className='btn btn-primary' name='action' value='CONFIRM'>登録</button>
            </footer>
          </fieldset>
        </div>
      </form>
    )
  }
}
export default KenkouSetting



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/KenkouSetting.js